const BROWSER_EXTENSION = '-extension://';
const ANONYMOUS = '<anonymous>';

// see https://github.com/thomaschampagne/elevate/blob/fc5772a12327c0d5015fb0fec64aba1cec6756c7/webextension/scripts/processors/activities-synchronize.ts
const ELEVATE_APP_CONSOLE_LOGS = [
  'Fast sync mode enabled',
  'A previous sync exists on',
  'local and remote activities count matches',
  'Mismatch found between local and remote activities. Syncing first page only.',
  'Activities fetched in group',
  ', raw activities length: ',
  'PagesRidden] Resolving with ',
  'clearSyncCache requested',
  'Group handled count: ',
  'Updating synced activities to extension local storage.',
  'Activities fetched in group'
];

export const hasExtensionReferenceInHintErrorStack = (hint) =>
  hint?.originalException?.stack?.includes(BROWSER_EXTENSION);

export const hasExtensionReferenceInBreadCrumbs = (event) =>
  !!event?.breadcrumbs?.find((entry) => {
    return (
      entry.data?.url?.includes(BROWSER_EXTENSION) ||
      ELEVATE_APP_CONSOLE_LOGS.includes(entry.message)
    );
  });

export const hasExtensionReferenceInEventErrorStack = (event) => {
  return !!event?.exception?.values?.find((entry) => {
    return !!entry.stacktrace?.frames?.find(
      (frame) =>
        frame?.filename?.includes(BROWSER_EXTENSION) ||
        frame?.abs_path?.includes(BROWSER_EXTENSION) ||
        frame?.filename?.includes(ANONYMOUS) ||
        frame?.abs_path?.includes(ANONYMOUS)
    );
  });
};

export default {
  hasExtensionReferenceInHintErrorStack,
  hasExtensionReferenceInBreadCrumbs,
  hasExtensionReferenceInEventErrorStack
};
